import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import moment from "moment";
import Util from "../../../util/Util";
import { AiOutlineCalendar } from "react-icons/ai";

class DailyAttendanceBySalesPersonReport extends React.Component {
  constructor(props) {
    super(props);

    const model = reactLocalStorage.getObject(Constants.Model);
    const userOptions = model.user.options || [];

    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();

    this.state = {
      selectedMonth: currentMonth,
      selectedYear: currentYear,
      userOptions,
      tableData: [],
      exportData: [],
      totalCounts: {},
      inApiCall: false,
    };
  }

  hasValidTime = (partText) => {
    if (!partText || typeof partText !== "string") return false;
    const timePattern = /(\d{1,2}:\d{2}\s?[AP]M)/i;
    return timePattern.test(partText);
  };

  addFiveThirtyToIST = (timeText) => {
    if (!timeText || timeText === "No Attendance" || timeText === "Absent") {
      return timeText;
    }
    try {
      const checkInMatch = timeText.match(/Check-In:\s*(\d{1,2}:\d{2}\s?[AP]M)/i);
      const checkOutMatch = timeText.match(/Check-Out:\s*(\d{1,2}:\d{2}\s?[AP]M)/i);

      const addTime = (timeStr) => {
        const parts = timeStr.trim().split(/\s+/);
        const timePart = parts[0];
        const period = parts[1] ? parts[1].toUpperCase() : "";
        let [hours, minutes] = timePart.split(":").map(Number);
        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;

        hours += 5;
        minutes += 30;
        if (minutes >= 60) {
          hours += 1;
          minutes -= 60;
        }
        if (hours >= 24) hours -= 24;

        let newPeriod = hours >= 12 ? "PM" : "AM";
        let displayHours = hours;
        if (hours === 0) displayHours = 12;
        else if (hours > 12) displayHours = hours - 12;

        return `${displayHours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")} ${newPeriod}`;
      };

      const newIn = checkInMatch ? addTime(checkInMatch[1]) : null;
      const newOut = checkOutMatch ? addTime(checkOutMatch[1]) : null;

      return `Check-In: ${newIn || "Not Done"} | Check-Out: ${newOut || "Not Done"}`;
    } catch (e) {
      return timeText;
    }
  };

  parseData = (response) => {
    const { selectedMonth, selectedYear, userOptions } = this.state;
    const daysInMonth = moment(`${selectedYear}-${selectedMonth}`, "YYYY-MM").daysInMonth();

    let tableData = [];
    let totalCounts = {};

    userOptions.forEach((u) => {
      const key = u.name || u.label || u.value;
      totalCounts[key] = { checkIn: 0, checkOut: 0 };
    });

    for (let day = 1; day <= daysInMonth; day++) {
      const formattedDate = `${day.toString().padStart(2, "0")}/${selectedMonth.toString().padStart(2, "0")}/${selectedYear}`;
      const keyDate = moment(`${selectedYear}-${selectedMonth}-${day}`, "YYYY-MM-DD").format("YYYY-MM-DD");

      const attendanceOfDay = response[keyDate] || [];
      let row = { date: formattedDate };

      userOptions.forEach((u) => {
        const key = u.name || u.label || u.value;
        const match = attendanceOfDay.find(a => a.user_id === u.value);

        if (match && match.text) {
          const converted = this.addFiveThirtyToIST(match.text);
          row[key] = converted;

          const parts = converted.split("|").map(p => p.trim());
          const checkInPart = parts[0] || "";
          const checkOutPart = parts[1] || "";

          if (this.hasValidTime(checkInPart)) {
            totalCounts[key].checkIn += 1;
          }

          if (this.hasValidTime(checkOutPart)) {
            totalCounts[key].checkOut += 1;
          }
        } else {
          row[key] = "Absent";
        }
      });

      tableData.push(row);
    }

    return { tableData, totalCounts };
  };

  fetchApi = () => {
    const { selectedMonth, selectedYear } = this.state;
    const body = { year: selectedYear, month: selectedMonth };

    this.setState({ inApiCall: true });

    DailySalesReportAPI.getDailyAttendenceReport(
      body,
      (response) => {
        this.onSuccess(response);
      },
      (error) => {
        console.error("API Failed:", error);
        this.onFail(error);
      }
    );
  };

  onSuccess = (data) => {
    const { tableData, totalCounts } = this.parseData(data);

    const totalRow = { date: "Total" };
    this.state.userOptions.forEach((u) => {
      const key = u.name || u.label || u.value;
      const totals = totalCounts[key] || { checkIn: 0, checkOut: 0 };
      totalRow[key] = `CHECK-IN: ${totals.checkIn}, CHECK-OUT: ${totals.checkOut}`;
    });

    this.setState({
      tableData,
      exportData: [...tableData, totalRow],
      totalCounts,
      inApiCall: false,
    });
  };

  onFail = (err) => {
    console.error("Failed to fetch daily attendance", err);
    Util.showError("Failed to fetch attendance data. Please try again.");
    this.setState({ inApiCall: false });
  };

  handleMonthChange = (e) => {
    this.setState({ selectedMonth: e.target.value });
  };

  handleYearChange = (e) => {
    this.setState({ selectedYear: e.target.value });
  };

  render() {
    const {
      selectedMonth,
      selectedYear,
      tableData,
      exportData,
      userOptions,
      totalCounts,
      inApiCall,
    } = this.state;

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-md-8">
              <h1>Daily Attendance By Sales Executive</h1>
            </div>

            <div className="col-md-4 text-right">
              <CSVLink
                data={exportData}
                filename={`daily_attendance_report_${selectedMonth}_${selectedYear}.csv`}
                className="btn btn-success"
              >
                Export to CSV
              </CSVLink>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-3">
              <label htmlFor="month-select" className="form-label">Month</label>
              <select
                id="month-select"
                className="form-control"
                value={selectedMonth}
                onChange={this.handleMonthChange}
              >
                {Constants.Months.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label htmlFor="year-select" className="form-label">Year</label>
              <select
                id="year-select"
                className="form-control"
                value={selectedYear}
                onChange={this.handleYearChange}
              >
                {Array.from({ length: 15 }).map((_, i) => {
                  const year = moment().year() - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="col-md-3 d-flex align-items-end">
              <Button
                className="btn-primary"
                onClick={this.fetchApi}
                disabled={inApiCall}
              >
                {inApiCall ? "Loading..." : "Submit"}
              </Button>
            </div>
          </div>

          {tableData.length > 0 ? (
            <div className="table-responsive">
              <Table bordered striped>
                <thead className="table-dark">
                  <tr>
                    <th>Date</th>
                    {userOptions.map((u, i) => (
                      <th key={i}>{u.label}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className="table-hover">
                  {tableData.map((row, idx) => (
                    <tr key={idx}>
                      <td className="fw-bold">{row.date}</td>
                      {userOptions.map((u, i) => {
                        const key = u.name || u.label || u.value;
                        return <td key={i}>{row[key]}</td>;
                      })}
                    </tr>
                  ))}
                </tbody>

                <tfoot className="table-secondary fw-bold">
                  <tr>
                    <td>Total</td>
                    {userOptions.map((u, i) => {
                      const key = u.name || u.label || u.value;
                      const totals = totalCounts?.[key] || { checkIn: 0, checkOut: 0 };
                      return (
                        <td key={i}>
                          CHECK-IN: {totals.checkIn} | CHECK-OUT: {totals.checkOut}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              </Table>
            </div>
          ) : (
           <div className="text-center py-4">
              <p className="text-secondary fw-semibold" style={{ fontSize: "1rem" }}>
                Please select a month and year, then click <strong>Submit</strong>.
              </p>
            </div>

          )}
        </div>
      </ApiUiController>
    );
  }
}

export default DailyAttendanceBySalesPersonReport;